<template>
    <div>
        <h1 class="subtitle">Vendedores</h1>
        <div class="nj-cols">
            <div class="nj-card">
                <div class="nj-subtitle-1">Filtros</div>
                <div class="nj-cols form c3">
                    <div>
                        <div class="nj-label">Nombre</div>
                        <input type="text" class="nj-text" v-model="filters.ven_nombre" placeholder="" @keyup.enter="buscar()" ref="first">
                    </div>
                    <div>
                        <div class="nj-label">Documento identidad</div>
                        <input type="text" class="nj-text" v-model="filters.ven_documento_identidad" placeholder="" @keyup.enter="buscar()">
                    </div>
                    <div>
                        <div class="nj-label">Estado</div>
                        <select class="nj-select" v-model="filters.est_id" @change="buscar()">
                            <option value="null">todos los estados</option>
                            <option v-for="item in estados" :key="item.est_id" :value="item.est_id">{{ item.est_nombre }}</option>
                        </select>
                    </div>
                </div>
                <Buttons line>
                    <button class="nj-button" @click="buscar()">Buscar</button>
                    <button class="nj-button c-green" @click="popup({ componente: 'registrar', abrir: true })">Nuevo</button>
                </Buttons>
            </div>
            <div class="nj-card">
                <b-table :data="vendedores" :paginated="isPaginated" :per-page="perPage" :current-page.sync="currentPage" :pagination-simple="isPaginationSimple" :pagination-position="paginationPosition" :default-sort-direction="defaultSortDirection" :pagination-rounded="isPaginationRounded" :sort-icon="sortIcon" :sort-icon-size="sortIconSize" aria-next-label="Next page"
                    aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page">
                    <template slot-scope="props">
                        <b-table-column label="ID" header-class="is-info">{{ props.row.ven_id }}</b-table-column>
                        <b-table-column label="Vendedor" header-class="is-info">{{ props.row.ven_nombre }}</b-table-column>
                        <b-table-column label="Documento" header-class="is-info">{{ props.row.ven_documento_identidad }}</b-table-column>
                        <b-table-column label="Telefono" header-class="is-info">{{ props.row.ven_telefono }}</b-table-column>
                        <b-table-column label="Estado" header-class="is-info">
                            <b-field>
                                <b-tag :class="tagEstado(props.row.est_id)">{{ props.row.est_nombre }}</b-tag>
                            </b-field>
                        </b-table-column>
                        <b-table-column label="Opciones" header-class="is-info">
                            <div class="nj-flx">
                                <button class="nj-button icon c-blue" @click="popup({ componente: 'ver', abrir: true, ven_id: props.row.ven_id })" title="Ver"><i class="mdi-information"></i></button>
                                <button class="nj-button icon" @click="popup({ componente: 'modificar', abrir: true, ven_id: props.row.ven_id })" title="Modificar"><i class="mdi-pencil"></i></button>
                            </div>
                        </b-table-column>
                    </template>
                </b-table>
            </div>
        </div>
        <RegistrarVendedor v-if="activarRegistrar" @close="popup($event)" :ven_id="ven_id"></RegistrarVendedor>
        <VerVendedor v-if="activarVer" @close="popup($event)" :ven_id="ven_id"></VerVendedor>
        <ModificarVendedor v-if="activarModificar" @close="popup($event)" :ven_id="ven_id"></ModificarVendedor>
    </div>
</template>
<script>
import Toast from "../../util/toast"
import Keyboard from "../../util/keyboard"
import { AppService } from "../../services"
import { VendedorService, ResponseStatus } from "../../services"
import { Buttons } from "./../components"
import Arrays from "../../util/arrays"
import RegistrarVendedor from "./RegistrarVendedor.vue"
import VerVendedor from "./VerVendedor.vue"
import ModificarVendedor from "./ModificarVendedor.vue"

export default {
    name: "Vendedor",
    components: {
        Buttons,
        RegistrarVendedor,
        VerVendedor,
        ModificarVendedor,
    },
    data() {
        return {
            estados: [],
            filters: {
                ven_id: null,
                ven_nombre: null,
                ven_documento_identidad: null,
                est_id: null,
            },
            vendedores: [],
            ven_id: null,
            activarRegistrar: false,
            activarVer: false,
            activarModificar: false,
            isPaginated: true,
            isPaginationSimple: false,
            isPaginationRounded: false,
            paginationPosition: "bottom",
            defaultSortDirection: "asc",
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
            currentPage: 1,
            perPage: 10,
        }
    },
    methods: {
        buscar() {
            VendedorService.buscar({
                vendedor: this.filters
            }).then(
                response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.vendedores = response.data
                    }
                    else {
                        Toast.error(response.message)
                    }
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        tagEstado(id) {
            return this.estados.find((item) => item.est_id == id).styles
        },
        popup({ componente, abrir, buscar = false, id = null }) {
            this.ven_id = id
            switch (componente) {
                case "registrar":
                    // registrar 
                    this.activarRegistrar = abrir
                    break
                case "ver":
                    // ver
                    this.activarVer = abrir
                    break
                case "modificar":
                    // modificar
                    this.activarModificar = abrir
                    break
                case "all":
                    // cerrar todo
                    this.activarRegistrar = false
                    this.activarVer = false
                    this.activarModificar = false
                    break
            }
            if (buscar) {
                this.buscar()
            }
        },
    },
    mounted() {
        AppService.getData(["estados"]).then(
            response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.estados = Arrays.filter(response.data.estados, "est_codigo", ["activo", "inactivo"])
                    this.buscar()
                }
                else {
                    Toast.error(response.message)
                }
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
        this.$refs.first.focus()
    }
}
</script>

<style scoped></style>